import React from 'react'
import BaseFooter from 'components/Shared/BaseFooter/BaseFooter'

const ClientFooter = () => (
  <BaseFooter
    data-test-id="base-footer"
    showPricing={false}
    showTel={false}
    showMorningstarLogo={false}
    sidebarDataLoaded={false} />
)

export default ClientFooter



// WEBPACK FOOTER //
// ./src/components/Client/ClientFooter/ClientFooter.jsx